<app-navigation [class.hidden]="!showNav"></app-navigation>

<main [class.navBarEnable]="showNav" [class.main-scc]="isScc">
  <router-outlet></router-outlet>
</main>
